import { useParams } from 'react-router-dom';
import ServiceDetail from './service-detail';
import serviceContent from './service-content';

const ServiceDetailWrapper = () => {
  const { serviceType } = useParams();
  const content = serviceContent[serviceType];
  return <ServiceDetail serviceType={serviceType} content={content} />;
};

export default ServiceDetailWrapper;